import React from 'react';
import { Descriptions } from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getConnectionDiameterByCode } from 'utils/codes';

const FinalSpecification = ({ details }) => (
  <>
    <Descriptions
      bordered
      title="Conditions NEP"
      style={{ marginTop: '20px' }}
      size="small"
      column={{
        xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1
      }}
    >
      {details?.warmWatter && details?.warmWatterTemperature && (
      <Descriptions.Item key={details?.warmWatterTemperature} label="Eau chaude" span={2}>
        {`Température: ${details?.warmWatterTemperature} °C`}
        <br />
        {`Durée: ${details?.warmWatterDuration} minutes`}
      </Descriptions.Item>
      )}
      {details?.steam && details?.steamTemperature && (
      <Descriptions.Item key={details?.steamTemperature} label="Vapeur circuit ouvert" span={2}>
        {`Température: ${details?.steamTemperature} °C`}
        <br />
        {`Durée: ${details?.steamDuration} minutes`}
      </Descriptions.Item>
      )}
      {details?.hno3 && details?.hno3Concentration && (
      <Descriptions.Item key={details?.hno3Concentration} label="Acide nitrique (HNO3)" span={2}>
        {`Concentration: ${details?.hno3Concentration} %`}
        <br />
        {`Température: ${details?.hno3Temperature} °C`}
        <br />
        {`Durée: ${details?.hno3Duration} minutes`}
      </Descriptions.Item>
      )}
      {details?.h3po4 && details?.h3po4Concentration && (
      <Descriptions.Item key={details?.h3po4Concentration} label="Acide phosphorique (H3PO4)" span={2}>
        {`Concentration: ${details?.h3po4Concentration} %`}
        <br />
        {`Température: ${details?.h3po4Temperature} °C`}
        <br />
        {`Durée: ${details?.h3po4Duration} minutes`}
      </Descriptions.Item>
      )}
      {details?.cc && details?.ccConcentration && (
      <Descriptions.Item key={details?.ccConcentration} label="Composés chlorés" span={2}>
        {`Concentration: ${details?.ccConcentration} %`}
        <br />
        {`Température: ${details?.ccTemperature} °C`}
        <br />
        {`Durée: ${details?.ccDuration} minutes`}
      </Descriptions.Item>
      )}
      {details?.naoh && details?.naohConcentration && (
      <Descriptions.Item key={details?.naohConcentration} label="Hydroxyde de sodium (NaOH)" span={2}>
        {`Concentration: ${details?.naohConcentration} %`}
        <br />
        {`Température: ${details?.naohTemperature} °C`}
        <br />
        {`Durée: ${details?.naohDuration} minutes`}
      </Descriptions.Item>
      )}
      {details?.h2o2 && details?.h2o2Concentration && (
      <Descriptions.Item key={details?.h2o2Concentration} label="Peroxyde d'hydrogène (H2O2)" span={2}>
        {`Concentration: ${details?.h2o2Concentration} %`}
        <br />
        {`Température: ${details?.h2o2Temperature} °C`}
        <br />
        {`Durée: ${details?.h2o2Duration} minutes`}
      </Descriptions.Item>
      )}
      {details?.c2h4o3 && details?.c2h4o3Concentration && (
      <Descriptions.Item key={details?.c2h4o3Concentration} label="Acide peracétique (C2H4O3)" span={2}>
        {`Concentration: ${details?.c2h4o3Concentration} %`}
        <br />
        {`Température: ${details?.c2h4o3Temperature} °C`}
        <br />
        {`Durée: ${details?.c2h4o3Duration} minutes`}
      </Descriptions.Item>
      )}
    </Descriptions>
    <Descriptions
      bordered
      title="Cycle"
      style={{ marginTop: '20px' }}
      size="small"
      column={{
        xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1
      }}
    >
      <Descriptions.Item key={details?.hno3Concentration} label="Nombre de cycles">
        {details?.numberCycles}
      </Descriptions.Item>
      {details?.NepNeedValidation && (
        <Descriptions.Item key={details?.hno3Concentration} label="Validation demandée">
          {details?.NepNeedValidation === 'yes' ? 'Oui' : 'Non'}
        </Descriptions.Item>
      )}
    </Descriptions>
    <Descriptions
      bordered
      title="Normes"
      style={{ marginTop: '20px' }}
      size="small"
      column={{
        xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1
      }}
    >
      <Descriptions.Item
        key={details?.hno3Concentration}
        label="Est impactée par les trois impératifs normatifs à respecter
            (Bonnes pratiques, UE règlementation, FDA règlementation)"
        span={3}
      >
        {details?.hasGoodPractice ? 'Oui' : 'Non'}
      </Descriptions.Item>
      {!_.isEmpty(details.standards) && (
        <Descriptions.Item
          key={details?.standards}
          label="Est impactée par un des trois impératifs normatifs spécifique suivants"
          span={3}
        >
          {details?.standards.join()}
        </Descriptions.Item>
      )}
      {!_.isEmpty(details.environmentalConstraints) && (
        <Descriptions.Item
          key={details?.environmentalConstraints}
          label="Est impactée par une des trois contraintes environnementales suivantes"
          span={3}
        >
          {details?.environmentalConstraints.join()}
        </Descriptions.Item>
      )}
    </Descriptions>
    <Descriptions
      bordered
      title="Informations utilisation"
      style={{ marginTop: '20px' }}
      size="small"
      column={{
        xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1
      }}
    >
      <Descriptions.Item key={details?.hno3Concentration} label="Pression">
        {`${details?.pressure} bar`}
      </Descriptions.Item>
      <Descriptions.Item key={details?.hno3Concentration} label="Dépression">
        {`${details?.depressure} bar`}
      </Descriptions.Item>
      <Descriptions.Item key={details?.hno3Concentration} label="Température d’utilisation">
        {`${details?.useTemperature} °C`}
      </Descriptions.Item>
    </Descriptions>
    <Descriptions
      bordered
      title="Caractéristiques du flexible"
      style={{ marginTop: '20px' }}
    >
      {details?.r1Type && (
      <Descriptions.Item key={details?.r1Type} label="Raccord1" span={3}>
        {`Type: ${details?.r1Type}`}
        <br />
        {`Diamètre: ${getConnectionDiameterByCode(details?.r1Type.split(' ')[0], details?.r1Diameter)} mm`}
        <br />
        {`Coude: ${details?.r1RightAngled === 0 ? 'Non' : details?.r1RightAngled}`}
        {details?.r1RightAngled !== 0 ? ' %' : ''}
        <br />
        {details?.r1asherNumber > 0 && (
          `${details?.r1asherNumber} rondelle(s) ${details?.r1WasherColor === 'yellow' ? ' couleur jaune' : ' couleur rouge'}`
        )}
      </Descriptions.Item>
      )}
      {details?.r2Type && (
      <Descriptions.Item key={details?.r2Type} label="Raccord2" span={3}>
        {`Type: ${details?.r2Type}`}
        <br />
        {`Diamètre: ${getConnectionDiameterByCode(details?.r2Type.split(' ')[0], details?.r2Diameter)} mm`}
        <br />
        {`Coude: ${details?.r2RightAngled === 0 ? 'Non' : details?.r2RightAngled}`}
        {details?.r2RightAngled !== 0 ? ' %' : ''}
        <br />
        {details?.r2asherNumber > 0 && (
          `${details?.r2asherNumber} rondelle(s) ${details?.r2WasherColor === 'yellow' ? ' couleur jaune' : ' couleur rouge'}`
        )}
      </Descriptions.Item>
      )}
      {details?.length && (
      <Descriptions.Item key={details?.length} label="Tuyau" span={3}>
        {`Longeur de joint à join: ${details?.length} mm`}
        <br />
        {`Diamètre: ${details?.diameter} mm`}
      </Descriptions.Item>
      )}
    </Descriptions>
  </>
);

FinalSpecification.propTypes = {
  details: PropTypes.shape({
    isFlexibleSpecifications: PropTypes.string,
    warmWatter: PropTypes.bool,
    warmWatterTemperature: PropTypes.number,
    warmWatterDuration: PropTypes.number,
    steam: PropTypes.bool,
    steamTemperature: PropTypes.number,
    steamDuration: PropTypes.number,
    hno3: PropTypes.bool,
    hno3Temperature: PropTypes.number,
    hno3Concentration: PropTypes.number,
    hno3Duration: PropTypes.number,
    h3po4: PropTypes.bool,
    h3po4Temperature: PropTypes.number,
    h3po4Duration: PropTypes.number,
    h3po4Concentration: PropTypes.number,
    cc: PropTypes.bool,
    ccTemperature: PropTypes.number,
    ccDuration: PropTypes.number,
    ccConcentration: PropTypes.number,
    naoh: PropTypes.bool,
    naohConcentration: PropTypes.number,
    naohDuration: PropTypes.number,
    naohTemperature: PropTypes.number,
    h2o2: PropTypes.bool,
    h2o2Concentration: PropTypes.number,
    h2o2Duration: PropTypes.number,
    h2o2Temperature: PropTypes.number,
    c2h4o3: PropTypes.bool,
    c2h4o3Concentration: PropTypes.number,
    c2h4o3Duration: PropTypes.number,
    c2h4o3Temperature: PropTypes.number,
    duration: PropTypes.number,
    r1Type: PropTypes.string,
    r1Diameter: PropTypes.number,
    r2Type: PropTypes.string,
    r2Diameter: PropTypes.number,
    length: PropTypes.number,
    diameter: PropTypes.number,
    pressure: PropTypes.number,
    depressure: PropTypes.number,
    useTemperature: PropTypes.number,
    numberCycles: PropTypes.number,
    NepNeedValidation: PropTypes.string,
    hasGoodPractice: PropTypes.bool,
    standards: PropTypes.arrayOf(PropTypes.string),
    environmentalConstraints: PropTypes.arrayOf(PropTypes.string),
    r1RightAngled: PropTypes.number,
    r2RightAngled: PropTypes.number,
    r1asherNumber: PropTypes.number,
    r2asherNumber: PropTypes.number,
    r1WasherColor: PropTypes.string,
    r2WasherColor: PropTypes.string,
  }),
};

export default FinalSpecification;
